import { render, staticRenderFns } from "./CollapseWithIcon.vue?vue&type=template&id=2a8e4ade&scoped=true"
import script from "./CollapseWithIcon.vue?vue&type=script&lang=js"
export * from "./CollapseWithIcon.vue?vue&type=script&lang=js"
import style0 from "./CollapseWithIcon.vue?vue&type=style&index=0&id=2a8e4ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e4ade",
  null
  
)

export default component.exports